<template>
  <!-- Banner global de "sin conexión" — aparece arriba de todo, en cualquier
       layout, y desaparece al reconectar (G-245). -->
  <AppOfflineBanner />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <GlobalOverlays />
</template>

<script setup lang="ts">
import AppOfflineBanner from '~/components/AppOfflineBanner.vue'
import GlobalOverlays from '~/components/ui/GlobalOverlays.vue'
</script>
